import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../ui/custom-table";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import { deleteUsecaseId, UseCaseeventListApi } from "../../api/api";

function Usecase() {
  const dispatch = useDispatch();
  const [usecase, setUsecase] = useState([]);
  console.log("usecase", usecase);
  const [loading, setLoading] = useState(false);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const columns = useMemo(
    () => [
      { accessorKey: "usecase_name", header: "Usecase Name" },
      { accessorKey: "usecase_description", header: "Usecase Description" },
      { accessorKey: "server_url", header: "Server url" },
      { accessorKey: "operation", header: "Operation" },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDUSECASE",
        showModal: true,
      })
    );
  };

  const fetchUsecase = async () => {
    setLoading(true);
    try {
      const data = await UseCaseeventListApi("", user_id, organization_id);
      if (data) {
        setUsecase(data?.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsecase();
  }, []);

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDUSECASE",
        showModal: true,
        data: row._id,
      })
    );
  };

  useEffect(() => {
    if (showModal === false) {
      fetchUsecase();
    }
  }, [showModal]);

  const handleDelete = async (controller) => {
    try {
      await deleteUsecaseId(controller?._id, user_id, organization_id);
      fetchUsecase();
    } catch (error) {
      console.error("Delete failed:", error.response?.data || error.message);
    }
  };

  return (
    <>
      {" "}
      <aside className="mainSection">
        <CustomTable
          columns={columns}
          data={usecase}
          loading={loading}
          onAddClick={handleAddClick}
          addButtonLabel="Add Usecase"
          onEdit={handleEdit}
          showActions={true}
          onDelete={handleDelete}
          // onView={handleView}
          // showViewButton={true}
          //   pagination={pagination}
          //   onPaginationChange={(updater) => {
          //     setPagination((prev) => {
          //       const newPagination =
          //         typeof updater === "function"
          //           ? updater(prev)
          //           : { ...prev, ...updater };
          //       return newPagination;
          //     });
          //   }}
          //   rowCount={totalRows}
          //   onSearchChange={(e) => {
          //     setSearchTerm(e.target.value);
          //     setPagination({ pageIndex: 0, pageSize: 10 }); // Reset pagination on search
          //   }}
        />
      </aside>
    </>
  );
}

export default Usecase;
